/* eslint-disable linebreak-style */
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { CashRegisterService } from '../cash-register.service';
import { ICashRegisterOpen } from '../cash-register.interface';
import { TokenService } from 'src/app/auth/services/token/token.service';
@Component({
  selector: 'pg-cash-register-open',
  templateUrl: './cash-register-open.component.html'
})
export class CashRegisterOpenComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  select = {
    pointOfSale: {
      openDialog: false,
      type: 'single',
      id: null,
      selected: false
    }
  };
  constructor(
    private fb: FormBuilder,
    private serviceBase: CashRegisterService,
    private tokenService: TokenService
  ) {
    super('Abrir Caja Registradora', serviceBase);
  }

  ngOnInit(): void {
    this.fg = this.fb.group({
      pointOfSale: ['Seleccionar', Validators.required],
      initialBalance: ['1.00', [Validators.required]]
    });
  }

  async onSubmit() {
    if (this.checkReadyToOpen()) {
      await this.createItem$(
        this.parseData(this.fg.value) as ICashRegisterOpen
      );
      if (this.message.status === 201) {
        this.tokenService.setCanSale(true);
      }
    }
  }

  parseData(form) {
    return {
      pointOfSaleId: this.select.pointOfSale.id,
      initialBalance: form.initialBalance
    };
  }

  onSelectedPointOfSale(pointOfSale) {
    if (pointOfSale) {
      this.fg
        .get('pointOfSale')
        .setValue(pointOfSale.branchStoreName + ' - ' + pointOfSale.code);
      this.select.pointOfSale.id = pointOfSale.id;
      this.select.pointOfSale.selected = true;
    }
    this.select.pointOfSale.openDialog = false;
  }

  checkReadyToOpen() {
    return this.select.pointOfSale.selected && this.fg.value;
  }
}
